import React from 'react'
import ReactImageMagnify from 'react-image-magnify';
const Zooming = () => {
    let watchImg1200 = "https://www.ulmapackaging.co.uk/en/packaging-solutions/produce/fresh-fruit-in-trays/pink-lady-apples-tray-packaging-in-stretch-film/1942_1.jpg/@@images/08d9c6b9-4791-4671-bfe9-c3c9fbbf0983.jpeg"
    return (
        <div id='zooimg' className='text-center' >

            <ReactImageMagnify style={{ zIndex: "1" }} className='text-center img-fluid'   {...{
                smallImage: {
                    "src": watchImg1200,
                    "isFluidWidth": true,

                    // "height": auto,

                },
                largeImage: {
                    "src": watchImg1200,
                    "width": 1800,
                    "height": 1800,


                }
            }} />

            {/* <img className='img-fluid' src={`${process.env.REACT_APP_API}uploads/${images[slideIndex]}`} style={{ width: '70%', height: "300px" }} alt={`Image ${slideIndex + 1}`} /> */}
        </div>
    )

}

export default Zooming